// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.group[data-v-5f600e7d] {\n  margin: 1rem 0 1rem 1rem;\n}\n.error[data-v-5f600e7d] {\n  color: var(--danger);\n}\n", ""]);
// Exports
module.exports = exports;
